"use client";
import { useSimulationSocket } from '@/hooks';
import {
  ClientToServerEvents,
  FetchSimulationSocketType,
  HistorySimulationDocketType,
  ServerToClientEvents,
  UpdateSimulationSocketType,
} from '@/types/SimulationSocketTypes';
import { TSetState } from '@/types/TSetState';
import { createContext, useContext, useState } from 'react';
interface SimulationSocketContextProps {
  fetchingData: FetchSimulationSocketType | null;
  historyData: HistorySimulationDocketType[] | null;
  simulationData: UpdateSimulationSocketType | null;
  status: string;
  setStatus: TSetState<string>;
}

const SimulationSocketContext = createContext<
  SimulationSocketContextProps | undefined
>(undefined);

export const SimulationSocketProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [socket, setSocket] = useState<any>(null);
  const { fetchingData, historyData, simulationData, status, setStatus } =
    useSimulationSocket({
      socket,
      setSocket,
    });

  return (
    <SimulationSocketContext.Provider
      value={{ fetchingData, historyData, simulationData, status, setStatus }}
    >
      {children}
    </SimulationSocketContext.Provider>
  );
};

export const useSimulationSocketContext = () => {
  const context = useContext(SimulationSocketContext);
  if (!context)
    throw new Error(
      'SimulationSocket must be used within a SimulationSocketProvider'
    );
  return context;
};
